import React from 'react';

const CustomHeader = () => {
  return (
    <div className='header-container h-0'></div>
  );
};

export default CustomHeader;